/* ============================================================
   ORA DROP — single source of truth for the current drop.
   Change these fields for each new drop (DROP 002, 003…): the bar, the homepage
   hero, the /drop page and the product cards update without touching the HTML.

   - state     : 'coming_soon' | 'early_access' | 'live' | 'ending' | 'closed' | 'sold_out'
                 (the bar and badges only ever show the real state)
   - opensAt   : launch date shown (YYYY-MM-DD)
   - closesAt  : ISO date-time — countdown shown ONLY when state is 'ending' AND it is a real future date
   - headline / description : hero copy, per language
   - image     : hero product image (transparent or white background). null = typographic hero, no empty frame
   - cta       : null = label/url follow the state automatically; or { fr, en, url } to force them
   - checkoutUrl : pre-order link (used only when 'live' / 'ending')
   - products  : size, doughLabel, note and visual (mood crop shown at the top of the card) are optional. Values not finalized stay null
                 (shown as "À venir"). Never invent them.
   DROP pizza standard (user-validated 2026-10-04): 26 cm · 180 g de pâton · ≈ 75 g glucides · ≈ 380 kcal
   = DOUGH BASE ONLY, BEFORE TOPPINGS (always shown with the "avant garniture" note).
   DROP pasta standard (user-validated): 150 g de pâtes fraîches (before cooking) · ≈ 75 g glucides · ≈ 410 kcal
   = PASTA ONLY, BEFORE SAUCE AND TOPPINGS (always shown with that note).
   Professional (Équipes & clubs) portioning is separate and stays adjustable to the staff's targets.
   ============================================================ */
window.ORA_DROP = {
  number: '001',
  name: 'Reload',
  state: 'coming_soon',
  opensAt: '2027-01-10',
  opensAtISO: '2027-01-10T10:00:00+01:00',  // countdown on the Drop page (Shopify: Theme settings > ORA Drop > Ouverture)
  closesAt: null,

  headline:    { fr: 'Le goût. Les macros.', en: 'The taste. The macros.' },
  description: { fr: 'Pizzas & pâtes en édition limitée.', en: 'Pizza & pasta in limited editions.' },
  image: null,
  /* To show a product photo again:
  image: {
    src: (window.ORA_ASSET_BASE || '/img/') + 'drop-001-hero.webp', width: 1100, height: 1100,
    srcMobile: (window.ORA_ASSET_BASE || '/img/') + 'drop-001-hero-640.webp', widthMobile: 640,
    alt: { fr: 'Pizza ORA du Drop 001 Reload', en: 'ORA Drop 001 Reload pizza' }
  }, */
  cta: null,

  checkoutUrl: null,
  next: '002',
  /* showPrices: false = prices are NOT shown anywhere on the site for now (user decision 2026-10-04).
     Set to true to display the pack prices again (values below are kept). */
  showPrices: false,
  /* Reload Drop packs (user-set prices, delivery included). Unit price is computed.
     badge: never "most popular" before real sales exist. */
  /* Pack card texts (empty = built-in text). Shopify: Theme settings > ORA Drop > Cartes des packs.
     Per pack you can also set desc: { fr, en } to replace the description of that card only. */
  cardText: {
    fr: { soon: 'Prochainement', desc: 'Pâte d’exception & ingrédients premium sous température contrôlée.', join: 'Inscrivez-vous sur la liste d’attente pour accéder au Drop.', priceSoon: 'Prix dévoilé le [date]' },
    en: { soon: 'Coming soon', desc: 'Exceptional dough & premium ingredients, temperature-controlled.', join: 'Join the waiting list to get access to the Drop.', priceSoon: 'Price revealed on [date]' }
  },
  packs: [
    { id: 'drop01', name: '1× Drop', units: 1,  price: null, image: { src: (window.ORA_ASSET_BASE || '/img/') + 'pack-01.webp', srcSmall: (window.ORA_ASSET_BASE || '/img/') + 'pack-01-sm.webp', alt: { fr: 'ORA 1929 — 1 boîte', en: 'ORA 1929 — 1 box' } }, who: null, badge: null },
    { id: 'drop04', name: '4× Drop', units: 4,  price: 59,  image: { src: (window.ORA_ASSET_BASE || '/img/') + 'pack-04.webp', srcSmall: (window.ORA_ASSET_BASE || '/img/') + 'pack-04-sm.webp', alt: { fr: 'ORA 1929 — 4 boîtes', en: 'ORA 1929 — 4 boxes' } },  who: { fr: 'Pour une personne', en: 'For one person' }, badge: null },
    { id: 'drop08', name: '8× Drop', units: 8,  price: 89,  image: { src: (window.ORA_ASSET_BASE || '/img/') + 'pack-08.webp', srcSmall: (window.ORA_ASSET_BASE || '/img/') + 'pack-08-sm.webp', alt: { fr: 'ORA 1929 — 8 boîtes', en: 'ORA 1929 — 8 boxes' } },  who: { fr: 'Pour deux personnes', en: 'For two people' }, badge: { fr: 'Recommandé', en: 'Recommended' } },
    { id: 'drop12', name: '12× Drop', units: 12, price: 109, image: { src: (window.ORA_ASSET_BASE || '/img/') + 'pack-12.webp', srcSmall: (window.ORA_ASSET_BASE || '/img/') + 'pack-12-sm.webp', alt: { fr: 'ORA 1929 — 12 boîtes', en: 'ORA 1929 — 12 boxes' } }, who: null, badge: { fr: 'Le plus avantageux', en: 'Best value' } }
  ],
  products: [
    { id: 'pizza-reload', format: 'pizza', name: 'Pizza Reload', mark: '26', size: { fr: 'Format performance 26 cm', en: '26 cm Performance Format' },
      visual: { src: (window.ORA_ASSET_BASE || '/img/') + 'pizza-real-940.webp', w: 900, h: 1600, srcSmall: (window.ORA_ASSET_BASE || '/img/') + 'pizza-real-560.webp', wSmall: 560, pos: '50% 48%', alt: { fr: 'Pizza ORA', en: 'ORA pizza' } },
      dough: '180 g', doughLabel: { fr: 'Pâton', en: 'Dough ball' },
      carbs: '≈ 75', kcal: '≈ 380', protein: null,
      note: { fr: 'Valeurs de la base pâte, avant garniture.', en: 'Dough-base values, before toppings.' },
      price: null, status: null },
    { id: 'pasta-reload', format: 'pasta', name: 'Pasta Reload', mark: 'P',
      size: { fr: 'Pâtes fraîches', en: 'Fresh pasta' },
      visual: { src: (window.ORA_ASSET_BASE || '/img/') + 'pasta-flour-1200.webp', srcSmall: (window.ORA_ASSET_BASE || '/img/') + 'pasta-flour-700.webp', pos: '80% 50%', alt: { fr: 'Pâtes fraîches ORA, visuel d’ambiance', en: 'ORA fresh pasta, mood image' } },
      dough: '150 g', doughLabel: { fr: 'Portion', en: 'Portion' },
      carbs: '≈ 75', kcal: '≈ 410', protein: null,
      note: { fr: 'Valeurs des pâtes seules, avant sauce et garniture.', en: 'Pasta-only values, before sauce and toppings.' },
      price: null, status: null }
  ]
};
